import { jsx as _jsx } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { ShowroomTileBadge } from "@faire/retailer-visitor-shared/components/Showroom/ShowroomTileBadge";
import { TopShopTileBadge } from "@faire/retailer-visitor-shared/components/TopShop/TopShopTileBadge";
import { Badge } from "@faire/web--source/slate/deprecated/Badge";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { TypographyStyles } from "@faire/web--source/slate/Typography";
import { IBadge } from "@faire/web-api--source/indigofair/badges/IBadge";
import React from "react";
import styled from "styled-components";
export var BadgeGuidepost = function(param) {
    var badge = param.badge, productToken = param.productToken;
    var _badge_style;
    if (!(((_badge_style = badge.style) === null || _badge_style === void 0 ? void 0 : _badge_style.badge_message) && badge.type && badge.display_to_user)) {
        return null;
    }
    switch(badge.type){
        case IBadge.BadgeType.SHOWROOM:
            return /*#__PURE__*/ _jsx(ShowroomTileBadge, {
                token: productToken,
                customEventName: "product-badge",
                tooltipZIndex: 1005
            });
        case IBadge.BadgeType.TOP_SHOP:
            return /*#__PURE__*/ _jsx(TopShopTileBadge, {
                content: badge.style.badge_message
            });
        case IBadge.BadgeType.FAIRE_BESTSELLER:
        case IBadge.BadgeType.BRAND_BESTSELLER:
        case IBadge.BadgeType.NEW_BADGE:
        case IBadge.BadgeType.HIGH_SELL_THROUGH:
        case IBadge.BadgeType.BESTSELLER:
        case IBadge.BadgeType.PREVIOUSLY_ORDERED:
        case IBadge.BadgeType.TRENDING:
            return /*#__PURE__*/ _jsx(StyledBadge, {
                content: badge.style.badge_message,
                backgroundColor: Core.surface.inverse
            });
        default:
            return null;
    }
};
var StyledBadge = styled(Badge).withConfig({
    componentId: "sc-2d2d5e69-0"
})([
    "max-width:100%;",
    " font-weight:500;padding:",
    ";cursor:pointer;display:block;"
], TypographyStyles({
    variant: "labelSansRegular",
    truncate: true,
    maxLines: 1
}), getSpacing(3, 7));
